"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _moment = _interopRequireDefault(require("moment"));
var _pricing = require("../../../helpers/pricing");
var _currency = require("../../../currency");
var _envConstants = require("../../../env-constants");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var prepareItemsToRender = function prepareItemsToRender(items, currency) {
  var itemsToRender = [];
  var lastAmount = null;
  items.forEach(function (item, i) {
    var isLast = items.length - 1 === i;
    var formattedAmount = (0, _pricing.formatCurrency)(item.amount, currency);
    var isOverdue = item.status === 'overdue';
    // is first
    if (i === 0) {
      var itemText = 'Deposit';
      if (item.bookingPage && item.status === 'paid') itemText = 'Amount Paid';
      if (item.bookingPage && item.type === 'deadline') itemText = 'First Deadline';
      itemsToRender.push({
        text: itemText,
        amount: item.amount,
        status: item.status,
        colourClassName: isOverdue ? 'd8-u-error-bg' : 'd8-u-success-dark-bg',
        items: [{
          text: "Due ".concat((0, _moment["default"])(item.dueDate).format('D MMM Y'), ", ").concat(formattedAmount),
          status: item.status
        }]
      });
    } else if (lastAmount === item.amount) {
      // this means it will not add to first item if it has same amount
      if (items.length > 1) {
        // if is same amount as previous but is also last item then we have to push it separately (same scheudled payments)
        // only when there are less then 3 items to render
        if (isLast && itemsToRender.length < 3) {
          itemsToRender.push({
            text: item.type === 'payment' ? 'Final Payment' : 'Final Deadline',
            amount: item.amount,
            status: item.status,
            colourClassName: isOverdue ? 'd8-u-error-bg' : 'd8-u-primary-bg',
            items: [{
              text: "Due ".concat((0, _moment["default"])(item.dueDate).format('D MMM Y'), ", ").concat(formattedAmount),
              status: item.status
            }]
          });
        } else {
          // else we will keep pushing to same main item
          itemsToRender[itemsToRender.length - 1].items.push({
            text: "Due ".concat((0, _moment["default"])(item.dueDate).format('D MMM Y'), ", ").concat(formattedAmount),
            status: item.status
          });
          var amountOfSameItems = itemsToRender[itemsToRender.length - 1].items.length;
          itemsToRender[itemsToRender.length - 1].text = item.type === 'payment' ? "".concat(amountOfSameItems, " Payments") : "".concat(amountOfSameItems, " Deadlines");
          if (isLast) {
            itemsToRender[itemsToRender.length - 1].colourClassName = isOverdue ? 'd8-u-error-bg' : 'd8-u-primary-bg';
          }
        }
      }
    } else {
      // this means adding item to render if previous and current amount is not same
      var isLastText = isLast ? 'Final' : '';
      var colourClassName = 'd8-u-primary-lighter-bg';
      if (isLastText) colourClassName = 'd8-u-primary-bg';
      if (isOverdue) colourClassName = 'd8-u-error-bg';
      itemsToRender.push({
        text: item.type === 'payment' ? "".concat(isLastText, " Payment") : "".concat(isLastText, " Deadline"),
        amount: item.amount,
        status: item.status,
        colourClassName: colourClassName,
        items: [{
          text: "Due ".concat((0, _moment["default"])(item.dueDate).format('D MMM Y'), ", ").concat(formattedAmount),
          status: item.status
        }]
      });
    }
    lastAmount = item.amount;
  });
  return itemsToRender;
};
var generateArrayOfColoursForBars = function generateArrayOfColoursForBars(itemsToRender) {
  var colours = [];
  itemsToRender.forEach(function (itemToRender, i) {
    var isFirst = i === 0;
    var isLast = i === itemsToRender.length - 1;
    var isOverdue = itemToRender.status === 'overdue';
    // check for item's child items - more than 1 because first one will always be actual parent
    if (itemToRender.items.length > 1) {
      itemToRender.items.forEach(function (childItem) {
        // if this is child of first main item should get the same colour
        if (isFirst) colours.push(childItem.status === 'overdue' ? 'd8-u-error-bg' : 'd8-u-success-dark-bg');
        // if this is child of last main item should get the same colour
        if (isLast) colours.push(childItem.status === 'overdue' ? 'd8-u-error-bg' : 'd8-u-primary-bg');
        // if main item is between first/last
        if (!isLast && !isFirst) colours.push(isOverdue ? 'd8-u-error-bg' : 'd8-u-primary-lighter-bg');
      });
    } else {
      var isOnlyOneItem = itemsToRender.length === 1;
      // if main item is first
      if (isFirst) colours.push(isOverdue ? 'd8-u-error-bg' : 'd8-u-success-dark-bg');
      // if main item is last
      if (isLast && !isOnlyOneItem) colours.push(isOverdue ? 'd8-u-error-bg' : 'd8-u-primary-bg');
      // if main item is between first/last
      if (!isLast && !isFirst) colours.push(isOverdue ? 'd8-u-error-bg' : 'd8-u-primary-lighter-bg');
    }
  });
  return colours;
};
var OrderItemsText = function OrderItemsText(_ref) {
  var items = _ref.items,
    currency = _ref.currency,
    showCurrency = _ref.showCurrency,
    fullyPaid = _ref.fullyPaid,
    setItemsColours = _ref.setItemsColours,
    totalGross = _ref.totalGross;
  (0, _react.useEffect)(function () {
    setItemsColours(generateArrayOfColoursForBars(itemsToRender));
  }, [items]);
  // this is to check if total amount of items matches order gross to identify if any of scheduled payments have failed therefore there will be some outsdanting amount due
  var sumItemsAmount = items.reduce(function (acc, i) {
    return acc + i.amount;
  }, 0);
  var leftoverAmount = Math.round(totalGross - sumItemsAmount);
  var itemsToRender = prepareItemsToRender(items, currency);
  var useDotsStyle = itemsToRender.length > 3;
  if (fullyPaid) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "margin-top-md text-component"
    }, /*#__PURE__*/_react["default"].createElement("p", {
      className: "text-md d8-u-text-bold"
    }, "Congratulations! You have fully paid!"), _envConstants.ENV.SITE === 'tyw' && /*#__PURE__*/_react["default"].createElement("p", null, "See you aboard \u26F5\uFE0F"), _envConstants.ENV.SITE === 'tsw' && /*#__PURE__*/_react["default"].createElement("p", null, "See you on the slopes \u26F7"));
  }
  return /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex justify-between margin-top-md ".concat(useDotsStyle && 'flex-column')
  }, itemsToRender.map(function (item, i) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      key: i,
      className: "flex width-100% ".concat(useDotsStyle && 'items-center')
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "".concat(item.colourClassName, " d8-u-radius-md"),
      style: {
        width: 'var(--space-xxs)',
        height: useDotsStyle && 'var(--space-xxs)'
      }
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: "margin-left-xs text-left ".concat(useDotsStyle && 'flex flex-center')
    }, /*#__PURE__*/_react["default"].createElement("span", {
      className: "d8-c-order-items-text-top text-xs text-sm@xs ".concat(useDotsStyle && 'margin-right-sm')
    }, item.text), /*#__PURE__*/_react["default"].createElement("p", {
      className: "d8-u-font-weight-500"
    }, /*#__PURE__*/_react["default"].createElement(_currency.FormatCurrency, {
      amount: item.amount,
      baseCurrency: currency,
      showCurrency: showCurrency
    }))));
  })), !!leftoverAmount && /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex justify-between margin-top-md flex-column"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex width-100% items-center"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "d8-u-error-bg d8-u-radius-md flex-shrink-0",
    style: {
      width: 'var(--space-xxs)',
      height: 'var(--space-xxs)'
    }
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "margin-left-xs text-left flex flex-center"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "d8-c-order-items-text-top text-xs text-sm@xs margin-right-sm"
  }, "Failed payments, please complete payment or contact our Customer Service team for queries"), /*#__PURE__*/_react["default"].createElement("p", {
    className: "d8-u-font-weight-500"
  }, /*#__PURE__*/_react["default"].createElement(_currency.FormatCurrency, {
    amount: leftoverAmount,
    baseCurrency: currency,
    showCurrency: showCurrency
  }))))));
};
OrderItemsText.propTypes = {
  items: _propTypes["default"].object.isRequired,
  currency: _propTypes["default"].string.isRequired,
  fullyPaid: _propTypes["default"].bool.isRequired,
  setItemsColours: _propTypes["default"].func.isRequired,
  showCurrency: _propTypes["default"].string,
  totalGross: _propTypes["default"].number
};
var _default = exports["default"] = OrderItemsText;